import { API } from '../config/config';

const buildQuery = (params = {}) => {
  const qp = new URLSearchParams();
  if (params.page) qp.append('page', String(params.page));
  if (params.page_size) qp.append('page_size', String(params.page_size));
  if (params.status) qp.append('status', params.status);
  if (params.q) qp.append('q', params.q);
  if (params.from) qp.append('from', params.from);
  if (params.to) qp.append('to', params.to);
  return qp.toString();
};

const getPrintJobs = async (storeId, params = {}, signal) => {
  if (!storeId) throw new Error('storeId is required');
  const query = buildQuery(params);
  const url = `/stores/${storeId}/print-jobs${query ? `?${query}` : ''}`;
  const response = await API.get(url, { signal });
  return response.data;
};

const getPrintJobStats = async (storeId, params = {}, signal) => {
  if (!storeId) throw new Error('storeId is required');
  // Stats use the same filters as the listing (status, q, from, to).
  const { page, page_size, ...statsParams } = params; // eslint-disable-line no-unused-vars
  const query = buildQuery(statsParams);
  const url = `/stores/${storeId}/print-jobs/stats${query ? `?${query}` : ''}`;
  const response = await API.get(url, { signal });
  return response.data;
};

const getPrintJob = async (id, signal) => {
  if (!id) throw new Error('id is required');
  const response = await API.get(`/print-jobs/${id}`, { signal });
  return response.data;
};

const reprintPrintJob = async (id) => {
  if (!id) throw new Error('id is required');
  const response = await API.post(`/print-jobs/${id}/reprint`);
  return response.data;
};

const downloadPrintJob = async (id) => {
  if (!id) throw new Error('id is required');
  const response = await API.get(`/print-jobs/${id}/download`, { responseType: 'blob' });
  return response.data;
};

const PrintJobsService = {
  getPrintJobs,
  getPrintJobStats,
  getPrintJob,
  reprintPrintJob,
  downloadPrintJob,
};

export default PrintJobsService;
